import Heading from 'components/heading/Heading';
import Icon from 'components/icon/Icon';
import Image from 'components/image/Image';
import Link from 'components/link/Link';
import LinkList from 'components/link-list/LinkList';
import RichText from 'components/rich-text/RichText';

import { IInfoBlock } from 'source/NFR.types';

const InfoBlock: React.FC<IInfoBlock> = ({ includeIcon, linkList, onPageEditing, title, text, url, cta, icon }) => {
  return (
    <div className="info-block">
      {title && (
        <div className="info-block--header">
          <Heading className="info-block--header-title" onPageEditing={onPageEditing?.title}>
            {url && url.url ? (
              <Link {...url} url={url.url} text={title} theme={['actionLink', 'wrappedHeadingForPrint', 'large']} />
            ) : (
              title
            )}
          </Heading>
          {icon && <Image className="info-block--icon-image" responsive={false} {...icon} />}
          {includeIcon && <Icon className="info-block--icon" name="i" />}
        </div>
      )}
      {text && <RichText className="info-block--text" {...text} />}
      {linkList && linkList.items && linkList.items.length > 0 && (
        <LinkList className="info-block--link-list" {...linkList} linkTheme="actionLink" />
      )}
      {cta && <Link className="info-block--cta-button" theme="primary" useButtonStyles {...cta} />}
    </div>
  );
};

InfoBlock.displayName = 'InfoBlock';

export default InfoBlock;
